import { authApiService } from './authService';

export const visitTypeApiService = {
  getVisitTypeOptions: async () => {
    const response = await authApiService.get('/visit-types/options');
    return response.data;
  },
}
